import "../fontawesome-config.js";
import "../fontawesome/fontawesome-all.js";
import "jquery";
import "jquery-validation";
import "jquery-validation-unobtrusive";
import "jquery-ui";
import "jquery-ui/ui/widgets/mouse";
import "jquery-ui-touch-punch";
import "../jquery.cascadingDropDown.js";
import "../usaj-validationSettings.js";
import "../Storage/basil.js";
import "../Storage/usajobs-storage.js";
import "../Analytics/usaj-analytics.js";
import "../usajobs-base.js";
import "../usajobsAutoComplete.js";
import "jquery-blockui";

var USAJOBS = USAJOBS || {};
USAJOBS.Base = USAJOBS.Base || {};

USAJOBS.Base = (function (window) {
    "use strict";

    var $ = window.jQuery,

    initialize = function () {
    };
    // end var

    return {
        init: initialize
    };
}(window));

$(document).ready(function () {
    "use strict";

    USAJOBS.Base.init();
});

// Alerts
var $alert = $('[data-object="alert"]');

$alert.on('click', '[data-behavior]', function (event) {
    var $el = $(this),
      $object = $el.closest('[data-object="alert"]'),
      $target = $object.find('#' + $el.attr('aria-controls')),
      state = $target.attr('aria-hidden'),
      behavior = $el.attr('data-behavior');

    event.preventDefault();
    $el.blur(); // Removes focus

    // Each behavior attached to the element should be triggered
    $.each(behavior.split(' '), function (idx, action) {
        if (action.match(/^alert/)) {
            $el.trigger(action, { el: $el, object: $object, target: $target, state: state });
        }
    });
});

$alert.on('alert.close', function (event, opts) {
    opts.object.attr('data-state', 'is-closed');
    opts.object.attr('aria-hidden', 'true');
});

$alert.on('alert.skip', function (event, opts) {
    var $next_tip = opts.object.find('#' + opts.el.attr('data-target-next'));

    opts.target.fadeOut('fast', function () {
        opts.target.attr('aria-hidden', 'true');
        $next_tip.attr('aria-hidden', 'false');
    });
});

$alert.on('alert.back', function (event, opts) {
    var $prev_tip = opts.object.find('#' + opts.el.attr('data-target-previous'));

    $prev_tip.fadeIn('fast', function () {
        opts.target.attr('aria-hidden', 'true');
        $prev_tip.attr('aria-hidden', 'false');
    });
});
